// Review-round chrome (the black "Feedback Preview" header, the feedback
// widget, the do-not-share gate) is preview-only: it renders ONLY when a
// deployment opts in with NEXT_PUBLIC_PREVIEW_MODE=1. Production builds leave
// the flag unset and ship none of it. Build-time constant (NEXT_PUBLIC_ vars
// are inlined by Next), so the gated components tree-shake out of prod
// bundles entirely.
export const IS_PREVIEW_MODE = process.env.NEXT_PUBLIC_PREVIEW_MODE === "1"
